(function(){
  "use strict";
  var LOCALE_PREFIXES = ['fr','en','de','it','es','pt','nl','ja','zh'];
  var SHOPIFY_ROUTES = /^\/(pages|products|collections|blogs|cart|account|search|policies)(\/|$|\?|#)/;

  function currentPrefix(){
    var p = (window.location.pathname || '').split('/')[1];
    return LOCALE_PREFIXES.indexOf(p) !== -1 ? '/' + p : '';
  }

  function localize(href, prefix){
    if(!href || !prefix) return href;
    if(href.charAt(0) !== '/') return href; // external / anchor / relative
    if(href.indexOf(prefix + '/') === 0 || href === prefix) return href;
    if(!SHOPIFY_ROUTES.test(href)) return href;
    return prefix + href;
  }

  // 1. Réécrit les href statiques
  function fixLinks(root){
    var prefix = currentPrefix();
    if(!prefix) return;
    var links = (root || document).querySelectorAll('a[href^="/"]');
    for(var i=0;i<links.length;i++){
      var a = links[i];
      var href = a.getAttribute('href');
      var newHref = localize(href, prefix);
      if(newHref !== href) a.setAttribute('href', newHref);
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ fixLinks(); });
  } else { fixLinks(); }

  // 2. Fallback : intercepte le clic — utile si le href change après nous ou si un autre script binde le click avant nous
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest && e.target.closest('a[href^="/"]');
    if(!a) return;
    if(e.defaultPrevented) return;
    if(e.button !== undefined && e.button !== 0) return;
    if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var prefix = currentPrefix();
    if(!prefix) return;
    var href = a.getAttribute('href');
    var newHref = localize(href, prefix);
    if(newHref !== href){
      a.setAttribute('href', newHref);
      // Ne bloque pas la navigation, on a juste réécrit à la volée
    }
  }, true);

  // 3. Re-scan pour les contenus injectés dynamiquement
  if(window.MutationObserver){
    var mo = new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        var added = muts[i].addedNodes;
        for(var j=0;j<added.length;j++){
          if(added[j].nodeType === 1) fixLinks(added[j]);
        }
      }
    });
    document.addEventListener('DOMContentLoaded', function(){
      mo.observe(document.body, {childList: true, subtree: true});
    });
  }
})();
